<div class="position-relative w-100 h-100">
    <i matTooltip="Cerrar" class="fas fa-times-circle fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <img *ngIf="getCurrentEvidence()?.type === 'image'" [src]="getCurrentEvidence()?.url | safe" alt="Evidence"
        class="w-100 mh-100vh" (error)="utils.onErrorRenderImage($event)">
    <embed *ngIf="getCurrentEvidence()?.type === 'pdf'" [src]="getCurrentEvidence()?.url | safe" type="application/pdf"
        width="100%" class="h-90vh" (error)="onErrorRenderPdf($event)">
    <i class="fas fa-chevron-circle-left fa-2xl" (click)="previous()" *ngIf="data.evidences.length > 1"></i>
    <i class="fas fa-chevron-circle-right fa-2xl" (click)="next()" *ngIf="data.evidences.length > 1"></i>
</div>